import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 24 24",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M12 5v13m-5-5 5 5 5-5" })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 24 24",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("rect", {
    x: "4",
    y: "3",
    width: "16",
    height: "18",
    rx: "3"
  }),
  /*#__PURE__*/_createElementVNode("path", { d: "M8 9h8M8 13h5" })
], -1)
const _hoisted_4 = [
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.b())
  }, [
    (_ctx.loading && !_ctx.displayedRows.length)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (!_ctx.isApplication)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(_ctx.b('columns', { application: _ctx.isApplication }))
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayedColumns, (column) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: column.id,
                    class: _normalizeClass(_ctx.b('column'))
                  }, [
                    _createElementVNode("p", {
                      class: _normalizeClass(_ctx.b('column-label'))
                    }, _toDisplayString(_ctx.$t(column.label)), 3)
                  ], 2))
                }), 128))
              ], 2))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.b('skeletons')),
            "aria-hidden": "true"
          }, [
            (_ctx.isApplication)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, _renderList(2, (index) => {
                  return _createElementVNode("div", {
                    key: index,
                    class: _normalizeClass(_ctx.b('skeleton-deal'))
                  }, [
                    _createElementVNode("div", {
                      class: _normalizeClass(_ctx.b('skeleton-deal-date'))
                    }, [
                      _createElementVNode("span", {
                        class: _normalizeClass(_ctx.b('bar')),
                        style: {"width":"84%","height":"13px"}
                      }, null, 2),
                      _createElementVNode("span", {
                        class: _normalizeClass(_ctx.b('bar')),
                        style: {"width":"62%","height":"10px","margin-top":"6px"}
                      }, null, 2)
                    ], 2),
                    _createElementVNode("div", {
                      class: _normalizeClass(_ctx.b('skeleton-deal-main'))
                    }, [
                      _createElementVNode("span", {
                        class: _normalizeClass(_ctx.b('bar')),
                        style: {"width":"44%","height":"16px"}
                      }, null, 2),
                      _createElementVNode("span", {
                        class: _normalizeClass(_ctx.b('bar')),
                        style: {"width":"82%","height":"16px"}
                      }, null, 2),
                      _createElementVNode("div", {
                        class: _normalizeClass(_ctx.b('skeleton-stage'))
                      }, [
                        _createElementVNode("span", {
                          class: _normalizeClass(_ctx.b('bar')),
                          style: {"width":"30%","height":"10px"}
                        }, null, 2),
                        _createElementVNode("span", {
                          class: _normalizeClass(_ctx.b('bar')),
                          style: {"width":"68%","height":"10px"}
                        }, null, 2)
                      ], 2)
                    ], 2),
                    _createElementVNode("span", {
                      class: _normalizeClass(_ctx.b('skeleton-pill'))
                    }, null, 2)
                  ], 2)
                }), 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, _renderList(4, (index) => {
                  return _createElementVNode("div", {
                    key: index,
                    class: _normalizeClass(_ctx.b('skeleton-row'))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayedSkeletonBarWidths, (width, i) => {
                      return (_openBlock(), _createElementBlock("span", {
                        key: i,
                        class: _normalizeClass(_ctx.b('bar')),
                        style: _normalizeStyle({ width })
                      }, null, 6))
                    }), 128))
                  ], 2)
                }), 64))
          ], 2)
        ], 64))
      : (_ctx.displayedRows.length)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (!_ctx.isApplication)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(_ctx.b('columns'))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayedColumns, (column) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: column.id,
                      class: _normalizeClass(_ctx.b('column'))
                    }, [
                      _createElementVNode("p", {
                        class: _normalizeClass(_ctx.b('column-label'))
                      }, _toDisplayString(_ctx.$t(column.label)), 3)
                    ], 2))
                  }), 128))
                ], 2))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.b('rows', { application: _ctx.isApplication }))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayedRows, (row) => {
                return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.displayedRow), {
                  key: _ctx.rowKey(row),
                  class: _normalizeClass(_ctx.b('row')),
                  row: (row as any),
                  onDepositWithdrawal: _ctx.handleDepositWithdrawal,
                  onRemove: _ctx.handleRemove,
                  onApplication: _ctx.handleApplication
                }, null, 40, ["class", "row", "onDepositWithdrawal", "onRemove", "onApplication"]))
              }), 128))
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.b('footer'))
            }, [
              _createElementVNode("span", {
                class: _normalizeClass(_ctx.b('count'))
              }, [
                _createTextVNode(_toDisplayString(_ctx.$t("Показано")) + " ", 1),
                _createElementVNode("b", null, _toDisplayString(_ctx.displayedRows.length), 1),
                _createTextVNode(" " + _toDisplayString(_ctx.$t(_ctx.isApplication ? "заявок" : "операций")), 1)
              ], 2),
              (_ctx.hasMoreItems)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: _normalizeClass(_ctx.b('show-more')),
                    disabled: _ctx.loading,
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleShowMore && _ctx.handleShowMore(...args)))
                  }, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t("Показать еще")), 1),
                    _hoisted_2
                  ], 10, _hoisted_1))
                : _createCommentVNode("", true)
            ], 2)
          ], 64))
        : (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: _normalizeClass(_ctx.b('empty'))
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.b('empty-orb'))
            }, _hoisted_4, 2),
            _createElementVNode("h3", null, _toDisplayString(_ctx.$t(_ctx.isApplication ? "Заявок не найдено" : "Ничего не найдено")), 1),
            _createElementVNode("p", null, _toDisplayString(_ctx.$t("Измените поисковый запрос или сбросьте фильтры.")), 1)
          ], 2))
  ], 2))
}